import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenService } from '@services/helper/token.service';

/**
 * Guard that protects private routes.
 *
 * Only blocks navigation when there is NO token at all. An expired token is
 * allowed through so the HTTP interceptor can attempt a token refresh — if we
 * wipe the token here on expiry, the subsequent /refresh call goes out without
 * a Bearer header and fails with 401.
 */
export const privateRouteGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  if (tokenService.getToken()) {
    return true;
  }

  return router.parseUrl('/auth/login');
};
